import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      clipPath: "url(#IconInfrastructureResort16a)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "m14.547 9.001-2.56-1.478c.356-.662.67-1.335.93-1.995a12.69 12.69 0 0 0 .697-2.361c.08-.452.121-.879.114-1.269a5.987 5.987 0 0 1 1.418 2.55 6 6 0 0 1-.6 4.553ZM10.134.053c.195.025.388.06.58.105a6.575 6.575 0 0 0-1.042.733 12.66 12.66 0 0 0-1.697 1.784 18.65 18.65 0 0 0-1.262 1.804L4.154 3a6 6 0 0 1 5.98-2.948Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m8.466 5.49-.886-.51c.37-.599.768-1.166 1.178-1.682a11.668 11.668 0 0 1 1.56-1.642c.507-.428.957-.698 1.324-.824.367-.127.583-.088.703-.019.12.07.262.237.336.618.074.381.066.906-.051 1.56a11.678 11.678 0 0 1-.643 2.172c-.242.613-.534 1.24-.867 1.86l-.922-.532-2.1 3.636.83.874H14v2H8.09L.94 5.406 2.35 4.07l4.313 4.544L8.466 5.49ZM2.398 16l2.454-4.25 1.431 1.52L4.707 16H2.398Zm8.383 0-1.154-2h2.31l1.154 2h-2.31Z"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "IconInfrastructureResort16a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        })
      })
    })]
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconInfrastructureResort16 = createIcon(IconComponent);